/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreUserRequest
 */
export interface StoreUserRequest {
    /**
     * 
     * @type {number}
     * @memberof StoreUserRequest
     */
    client_id: number;
    /**
     * 
     * @type {number}
     * @memberof StoreUserRequest
     */
    team_id?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreUserRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUserRequest
     */
    role: StoreUserRequestRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof StoreUserRequest
     */
    password: string;
}


/**
 * @export
 */
export const StoreUserRequestRoleEnum = {
    NgInactive: 'ng_inactive',
    NgUser: 'ng_user',
    NgSystemAdmin: 'ng_system_admin',
    NgSupervisor: 'ng_supervisor',
    NgServiceAccount: 'ng_service_account'
} as const;
export type StoreUserRequestRoleEnum = typeof StoreUserRequestRoleEnum[keyof typeof StoreUserRequestRoleEnum];


/**
 * Check if a given object implements the StoreUserRequest interface.
 */
export function instanceOfStoreUserRequest(value: object): value is StoreUserRequest {
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function StoreUserRequestFromJSON(json: any): StoreUserRequest {
    return StoreUserRequestFromJSONTyped(json, false);
}

export function StoreUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'team_id': json['team_id'] == null ? undefined : json['team_id'],
        'name': json['name'],
        'role': json['role'],
        'email': json['email'],
        'password': json['password'],
    };
}

export function StoreUserRequestToJSON(json: any): StoreUserRequest {
    return StoreUserRequestToJSONTyped(json, false);
}

export function StoreUserRequestToJSONTyped(value?: StoreUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_id': value['client_id'],
        'team_id': value['team_id'],
        'name': value['name'],
        'role': value['role'],
        'email': value['email'],
        'password': value['password'],
    };
}

